<template>
  <sea-page
    title="Importazione lavoratori"
    header="Importazione lavoratori"
    showCompanyHeader
    back
  >
    <sea-page-content
      ref="list"
      :fetchList="fetchList"
      :resetList="resetList"
      toolbar
      pulsanteAggiorna
      pulsanteAttivaUtente
      pulsanteAttivaUtenteDisabled
      @pulsanteAttivaUtenteClick ="openSendDialog"
    >
      <template v-slot:table="{ attrs, height }">
        <v-data-table
          v-model="attrs.selected"
          v-bind="attrs"
          :height="height"
          :headers="headers"
          :items="items"
          dense
          item-key="codiceFiscale"
          show-select
          @click:row="rowClick"
        >
        </v-data-table>
      </template>
      <sea-dialog
        ref="errorMessages"
        onlyMessage
        title="Si sono verificati degli errori"
      >
        <div
          style="max-heigth: 400px"
          class="overflow-y-auto"
          v-html="errors"
        ></div>
      </sea-dialog>
      <sea-dialog
        :max-width="500"
        ref="sendDialog"
        title="Modalità importazione"
        confirmLabel="Importa"
        @confirmed="importSelected"
        :confirmDisabled = "!radios"
      >
      <br>
    <v-radio-group v-model="radios">
      <v-row>
        <v-col cols="1">
          <v-radio label="" value="with"></v-radio>
        </v-col>
        <v-col cols="11">
          <span><b>Importa utente con email di attivazione accesso al portale.</b></span>
          <br>
          <span>(Il portale attiverà l'utente inviando un'email per inserire le credenziali di accesso)</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1">
          <v-radio label="" value="without"></v-radio>
        </v-col>
        <v-col cols="11">
          <span><b>Importa utente senza abilitare accesso al portale</b>.</span>
          <br>
          <span>(Il portale attiverà l'utente senza inviare l'email per inserire le credenziali di accesso)</span>
        </v-col>
      </v-row>
    </v-radio-group>
      </sea-dialog>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const headers = [
  {
    text: "Cognome",
    value: "cognome",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Nome",
    value: "nome",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Codice Fiscale",
    value: "codiceFiscale",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Email",
    value: "email",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
];
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.codiceAzienda && to.query.idAzienda) {
        vm.setCurrentCompany({
          codFiscale: to.query.codiceAzienda,
          id: to.query.idAzienda,
        });
        vm.setWCurrentCompany(to.query.codiceAzienda);
      }
    });
  },
  data() {
    return {
      headers,
      errors: null,
      radios: null,
    };
  },
  methods: {
    ...mapActions({
      fetchList: "proxy/fetchEmployees",
      resetList: "proxy/resetEmployees",
      setCurrentCompany: "proxy/setCurrentCompany",
      setWCurrentCompany: "widget/setCurrentCompany",
      importEmployees: "users/importEmployees",
      importEmployeesWithoutEmail: "users/importEmployeesWithoutEmail",
    }),
    rowClick: function (item, row) {
      row.select(!row.isSelected);
    },
    openSendDialog() {
      this.$refs.sendDialog.open();
    },
    importSelected() {
      this.errors = null;
      if(this.radios === "with") {
        this.importEmployees({
        employees: this.$refs.list.attrs.selected,
        idCompany: this.idCompany ? this.idCompany.id : null,
      }).then((res) => {
        if (res.length > 0) {
          this.$refs.errorMessages.open();
          this.errors = res;
        }
        this.$refs.list.attrs.selected = [];
        this.fetchList();
      });
      } else if(this.radios === "without"){
        this.importEmployeesWithoutEmail({
        employees: this.$refs.list.attrs.selected,
        idCompany: this.idCompany ? this.idCompany.id : null,
      }).then((res) => {
        if (res.length > 0) {
          this.$refs.errorMessages.open();
          this.errors = res;
        }
        this.$refs.list.attrs.selected = [];
        this.fetchList();
      });
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "proxy/employees",
      idCompany: "proxy/currentCompany",
    }),
  },
};
</script>

<style>
</style>
